import React, { useEffect, useState } from "react";
import CallsTab from "./CallsTab";
import { useParams } from "react-router-dom";
import { useGetLogspaginationQuery } from "src/services/ContactServices";

const CallsTabWrapper = () => {
  const { contactId } = useParams();
  const [callsData, setCallsData] = useState<any>();

  const { data, isLoading, isFetching } = useGetLogspaginationQuery({
    limit: 10,
    searchValue: "",
    params: ["description"],
    page: 0,
    filterBy: [
      {
        fieldName: "contactId",
        value: [contactId || ""],
      },
      {
        fieldName: "logType",
        value: ["CALL"],
      },
    ],
    dateFilter: {},
    orderBy: "createdAt",
    orderByValue: -1,
    isPaginationRequired: false,
  });

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setCallsData(data?.data);
    }
  }, [data, isLoading, isFetching]);
  return <CallsTab isLoading={isLoading || isFetching} callsData={callsData} />;
};

export default CallsTabWrapper;
